import styled from 'styled-components';

export const Wrapper = styled.div`
  margin-bottom: -4px;
  line-height: 0;
`;

export const Image = styled.img``;
